import React, {useEffect, useState} from "react";
import parse from 'html-react-parser';
import {mrbgStore} from "./mrbg/mrbgRedux";
import mrbgS2S from "../mrbgLib/mrbgS2S.js";
import MrbgLoader from "./mrbg/MrbgLoader.jsx";
import Footer from "./Footer.jsx";
import mainStyle from "../static/css/B_main.module.css"
import {Navigate} from "../../.vite/deps/react-router-dom.js";
import Menu from "./Menu.jsx";

function PagesOurTeam(){

  const
    [mrbgVars,setMrbgVars] = useState(mrbgStore.getState().mrbgVars),
    componentText = {
      'fa':{
        'name':'نام',
        'position':'پوزیشن',
        'webSite':'وب سایت'
      },
      'en':{
        'name':'name',
        'position':'position',
        'webSite':'website'
      },
      'du':{
        'name':'name',
        'position':'position',
        'webSite':'website'
      },
      'ar':{
        'name':'الاسم',
        'position':'الموضع',
        'webSite':'موقع إلكتروني'
      }
    };

  function parallax(){
    document.querySelectorAll('.PRL').forEach(elm=>{
      if( elm.getBoundingClientRect().top < window.innerHeight-50)
        elm.classList.remove('PRL')
    })
  }

  useEffect(()=>{
    const unsubscribe = mrbgStore.subscribe(()=>{
      setMrbgVars( mrbgStore.getState().mrbgVars );
    });

    window.addEventListener('scroll',parallax)
    return () =>{
      window.removeEventListener('scroll', parallax)
      unsubscribe();
    }
  },[])

  if( mrbgVars.pageInfo===undefined ){
    mrbgS2S( null, null, 'otm','load' );
    return <MrbgLoader />
  }
  else if( mrbgVars.urlPath==404 ){
    return <Opps404 />
  }
  else if( '/'+mrbgVars.urlPath!==decodeURI(window.location.pathname) ){
    return <Navigate replace to={`/${mrbgVars.urlPath}`}/>
  }
  else{
    document.title = mrbgVars.pageInfo.title;
    document.querySelector('meta[name="description"]').content = mrbgVars.pageInfo.description;
    document.documentElement.setAttribute( 'lang', mrbgVars.lang )

    return(
      <>
        <main id={mainStyle.blogMain}>
          <Menu {...{mainStyle}}/>
          <section id={mainStyle.ourTeamMemberSec}>
            <div className={mainStyle.flexRowDesk}>
              <div className={mainStyle.ourTemTblFrame}>
                <h1 id={mainStyle.ourTeamMemberH1}>{mrbgVars.memberInfo.name}</h1>
                <table className={mainStyle.ourTemTable}>
                  <tbody>
                  {
                    Object.keys(componentText[mrbgVars.lang]).map((propsName, i)=>{
                      return (
                        <tr key={i}>
                          <th>{componentText[mrbgVars.lang][propsName]} :</th>
                          <td>{mrbgVars.memberInfo[propsName]}</td>
                        </tr>
                      )
                    })
                  }
                  </tbody>
                </table>
              </div>
              <figure>
                <img src={`/img/${mrbgVars.memberInfo.img}`} alt={mrbgVars.memberInfo.alt}/>
              </figure>
            </div>
            <div id={mainStyle.ourTeamMemberDesc}>{parse(mrbgVars.memberInfo.description)}</div>
          </section>
          <Footer {...{mainStyle}}/>
        </main>
        <MrbgLoader/>
      </>
    )
  }
}

export default PagesOurTeam;